import React, { useState, useEffect, useContext, useCallback } from 'react';
import {
	Select,
	MenuItem,
	FormControl,
	InputLabel,
	Button,
	Stack,
	Box,
	TextField
} from '@mui/material';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import moment from 'moment';
import { DataContext } from '../../../../context/DataContext';
import { getToken } from '../../../../api/Account';
import {
	getGestoresAsync,
	getGestoresBySucursalAccessAsync,
	getSucursalByUserAsync
} from '../../../../api/Users';
import { getRuta, simpleMessage } from '../../../../helpers/Helpers';
import { faPrint } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { accionPrincipalSx } from '../../../../components/ui/accionPrincipal';

const TODOS = 't';

const SelectorRecuperacionEfectiva = () => {
	const [sucursalList, setSucursalList] = useState([]);
	const [selectedSucursal, setSelectedSucursal] = useState(TODOS);

	const [gestorList, setGestorList] = useState([]);
	const [selectedGestor, setSelectedGestor] = useState(TODOS);

	// Por defecto el mes en curso, que es el corte habitual para medir recuperacion.
	const [fechaDesde, setFechaDesde] = useState(moment().startOf('month').toDate());
	const [fechaHasta, setFechaHasta] = useState(new Date());

	const { setIsLoading, setIsUnautorized } = useContext(DataContext);
	const ruta = getRuta();
	const token = getToken();

	const manejarError = useCallback(
		(result) => {
			if (result.error === 'Unauthorized') {
				setIsUnautorized(true);
				return;
			}
			simpleMessage(result.error, 'error');
		},
		[setIsUnautorized]
	);

	const getGestores = useCallback(
		async (sucursal) => {
			const result =
				sucursal === TODOS
					? await getGestoresBySucursalAccessAsync(token)
					: await getGestoresAsync(token, sucursal);
			if (!result.statusResponse) {
				manejarError(result);
				return;
			}
			setGestorList(result.data.result);
		},
		[token, manejarError]
	);

	useEffect(() => {
		(async () => {
			setIsLoading(true);
			const result = await getSucursalByUserAsync(token);
			if (!result.statusResponse) {
				setIsLoading(false);
				manejarError(result);
				return;
			}
			setSucursalList(result.data.result);
			await getGestores(TODOS);
			setIsLoading(false);
		})();
	}, [token, setIsLoading, manejarError, getGestores]);

	const onChangeSucursal = async (value) => {
		setSelectedSucursal(value);
		setSelectedGestor(TODOS);
		setIsLoading(true);
		await getGestores(value);
		setIsLoading(false);
	};

	const verReport = () => {
		if (moment(fechaHasta).isBefore(fechaDesde)) {
			simpleMessage('La fecha hasta no puede ser anterior a la fecha desde', 'error');
			return;
		}
		const params = `${selectedSucursal}/${selectedGestor}/${moment(fechaDesde).format(
			'YYYY-MM-DD'
		)}/${moment(fechaHasta).format('YYYY-MM-DD')}`;
		window.open(`${ruta}/r-recuperacionefectiva/${params}`);
	};

	return (
		<div>
			<Box sx={{ width: '100%', maxWidth: 550 }}>
				<Stack spacing={2}>
					<FormControl fullWidth style={{ textAlign: 'left' }}>
						<InputLabel id="select-sucursal-label">Sucursal</InputLabel>
						<Select
							labelId="select-sucursal-label"
							onChange={(e) => onChangeSucursal(e.target.value)}
							value={selectedSucursal}
							label="Sucursal"
						>
							{sucursalList.map((item) => (
								<MenuItem key={item.id} value={item.id}>
									{item.description}
								</MenuItem>
							))}
							<MenuItem value={TODOS}>TODAS...</MenuItem>
						</Select>
					</FormControl>

					<FormControl fullWidth style={{ textAlign: 'left' }}>
						<InputLabel id="select-gestor-label">Gestor</InputLabel>
						<Select
							labelId="select-gestor-label"
							onChange={(e) => setSelectedGestor(e.target.value)}
							value={selectedGestor}
							label="Gestor"
						>
							{gestorList.map((item) => (
								<MenuItem key={item.id} value={item.id}>
									{item.fullName}
								</MenuItem>
							))}
							<MenuItem value={TODOS}>TODOS...</MenuItem>
						</Select>
					</FormControl>

					<DesktopDatePicker
						closeOnSelect
						label="Fecha desde"
						inputFormat="DD/MM/YYYY"
						value={fechaDesde}
						onChange={(newValue) => setFechaDesde(newValue)}
						renderInput={(params) => <TextField fullWidth {...params} />}
					/>

					<DesktopDatePicker
						closeOnSelect
						label="Fecha hasta"
						inputFormat="DD/MM/YYYY"
						value={fechaHasta}
						onChange={(newValue) => setFechaHasta(newValue)}
						renderInput={(params) => <TextField fullWidth {...params} />}
					/>

					<Button
						variant="contained"
						startIcon={<FontAwesomeIcon icon={faPrint} />}
						onClick={() => verReport()}
						sx={accionPrincipalSx}
					>
						Generar Reporte
					</Button>
				</Stack>
			</Box>
		</div>
	);
};

export default SelectorRecuperacionEfectiva;
